// import axios from 'axios'
// import Qs from 'qs'

// // 创建axios实例
// var baseURLStr = window.g.ApiUrl   //服务器地址
// var baseURLsrc = window.g.Apisrc   //拼接地址地址
// //  //console.log(baseURLStr)
// // 创建axios实例
// const instance = axios.create({
//     // baseURL: '/api'  //请求根路径
//     // baseURL: 'http://www.oa.com/api'
//     baseURL: baseURLStr
// })
// /* 
//     axios拦截器设置：
//         语法：
//             axios.interceptors.request(responese).use(config=>{
//                 // 必须返回config
//                 return config
//             },err=>{
//                 return Promise.reject(err)
//             })

//         拦截器内config包含当前请求（响应）全部信息，往往我们需要的是：method, data, headers
// */
// // 请求拦截——在请求之前，提前处理当前请求的配置项.此配置，全局生效
// // axios.defaults.baseURL = 'http://www.oa.com/api';
// instance.interceptors.request.use(config => {

//     // 获取本地token
//     let token = window.sessionStorage.getItem("token")
//     // let token = storage.token
//     // console.log(token);
//     // 将token添加到请求的header上
//     config.headers.token = token

//     // 判断如果是post请求则使用Qs转移请求参数体
//     if (config.method === 'post') {
//         config.data = Qs.stringify(config.data)
//     }
//     return config
// }, err => {
//     // 如果报错，可使用Promise.reject捕获错误
//     return Promise.reject(err)
// })

// // 响应拦截器
// // axios.defaults.baseURL = 'http://www.oa.com/api';
// instance.interceptors.response.use(config => {

//     return config;
// }, err => {
//     const realData = err.response.data
//     if (err.response && realData && realData.code === 401) {
//         // 以上三个条件全部满足时，才说明token超时
//         // 1. 触发actions中的logout函数，清除无效token、当前用户信息
//         window.sessionStorage.clear();
//         localStorage.clear();
//         // 2. 跳转到登录页面
//         location.reload();
//         this.$router.push({ path: "/login" });
//         // 3. return 一个执行错误，用于终止当前的promise执行链
//         return Promise.reject(err)
//     } else {
//         /*  如果token未失效，则是其他错误 */
//         // 2. return 一个执行错误
//         return Promise.reject(err)
//     }

// })

// export default instance;





import axios from 'axios'
import Qs from 'qs'
import VueCookie from 'vue-cookie'
import BUS from "../BUS/BUSs";
import storage from '@/utils/storage'
import { Store } from 'vuex'

var baseURLStr = window.g.ApiUrl   //服务器地址
var baseURLsrc = window.g.Apisrc   //拼接地址地址
//  //console.log(baseURLStr)
// 创建axios实例
const instance = axios.create({
    // baseURL: '/api'  //请求根路径
    // baseURL: 'http://www.oa.com/api'
    baseURL: baseURLStr
})
/* 
    axios拦截器设置：
        语法：
            axios.interceptors.request(responese).use(config=>{
                // 必须返回config
                return config
            },err=>{
                return Promise.reject(err)
            })
        
        拦截器内config包含当前请求（响应）全部信息，往往我们需要的是：method, data, headers
*/
// 请求拦截——在请求之前，提前处理当前请求的配置项.此配置，全局生效
// axios.defaults.baseURL = 'http://www.oa.com/api';
instance.interceptors.request.use(config => {

    let token = VueCookie.get("token")
    config.headers.token = token
    // 获取本地token
    // let token = storage.token
    // 将token添加到请求的header上

    // 判断如果是post请求则使用Qs转移请求参数体
    if (config.method === 'post') {
        config.data = Qs.stringify(config.data)
    }

    return config
}, err => {
    // 如果报错，可使用Promise.reject捕获错误
    return Promise.reject(err)
})


// 响应拦截器
// axios.defaults.baseURL = 'http://www.oa.com/api';
instance.interceptors.response.use(config => {
    if (config.status == 200) {
        if (config.data.code == 200) {
            if (config.data.msg.slice(-2) == "成功" || config.data.msg.slice(-2) == "ss" || config.data.status.slice(-2) == "ss") {
                return config
            } else {
                config.data.code = 500
                return config
            }
        } else if (config.data.code == 500) {
            return config
        } else {
            BUS.$emit("send", 0);
            window.sessionStorage.clear();
            localStorage.clear();
            let token = VueCookie.get("token");
            VueCookie.set("token", token, -2); //删除
        }
    } else if (config.status != 200) {
        BUS.$emit("send", 0);
        window.sessionStorage.clear();
        localStorage.clear();
        let token = VueCookie.get("token");
        VueCookie.set("token", token, -2); //删除
    }

    if (config.headers.token != undefined) {
        VueCookie.set("token", config.headers.token, 14 * 24 * 60 * 60);
    } else {
        console.log(config);
        // return config;
    }


}, err => {
    // console.log(err.response.status);
    // if (err.response.data.code == 401) {
    //     BUS.$emit("send", 0);
    //     window.sessionStorage.clear();
    //     localStorage.clear();
    //     let token = VueCookie.get("token");
    //     VueCookie.set("token", token, -2); //删除
    // }
    // return Promise.reject(err)
})

export default instance;


